module.exports = __webpack_public_path__ + "static/media/gcdef_10043.eee1cc59.ico";